var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.textList.length
    ? _c("span", { class: _vm.currentTheme }, [
        _vm._v(_vm._s(_vm.emphasisText))
      ])
    : _c("span", { class: _vm.theme }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }